import {
  addAssessmentActivityUrl,
  addInternalAuditActivityUrl,
  addOversightAssessmentActivityUrl,
  assessmentActivitiesDetailsUrl,
  assessmentActivitiesRegisterUrl,
  assessmentResultsUrl,
  internalAuditReportActivitiesDetailsUrl,
  internalAuditReportActivitiesRegisterUrl,
  internalAuditReportResultsUrl,
  oversightAssessmentActivitiesDetailsUrl,
  oversightAssessmentActivitiesRegisterUrl,
  oversightAssessmentResultsUrl,
} from '@/utils/urls';

import type { AssessmentTypeEnum } from './types';

interface AssessmentTypeConfig {
  routing: {
    resultsRegisterUrl: (id: string) => string;
    activityAddUrl: (id: string) => string;
    activityRegisterUrl: (id: string) => string;
    activityEditUrl: (id: string, activityId: string) => string;
  };
}

export const useAssessmentTypeConfig = (
  assessmentMode: AssessmentTypeEnum
): AssessmentTypeConfig => {
  switch (assessmentMode) {
    case 'rating': {
      return {
        routing: {
          resultsRegisterUrl: assessmentResultsUrl,
          activityAddUrl: addAssessmentActivityUrl,
          activityEditUrl: assessmentActivitiesDetailsUrl,
          activityRegisterUrl: assessmentActivitiesRegisterUrl,
        },
      };
    }
    case 'oversight_assessment': {
      return {
        routing: {
          resultsRegisterUrl: oversightAssessmentResultsUrl,
          activityAddUrl: addOversightAssessmentActivityUrl,
          activityEditUrl: oversightAssessmentActivitiesDetailsUrl,
          activityRegisterUrl: oversightAssessmentActivitiesRegisterUrl,
        },
      };
    }
    case 'internal_audit_report': {
      return {
        routing: {
          resultsRegisterUrl: internalAuditReportResultsUrl,
          activityAddUrl: addInternalAuditActivityUrl,
          activityEditUrl: internalAuditReportActivitiesDetailsUrl,
          activityRegisterUrl: internalAuditReportActivitiesRegisterUrl,
        },
      };
    }
  }
};
